import controller from './kform-builder-option-shortcut.controller';
import template from './kform-builder-option-shortcut.html';

const kformBuilderOptionShortcutDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionShortcutDirective;
